import React from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import { isNil, has } from '../../../services/helper';
import style from './caravanInsideImage.scss';

function CaravanInsideImage(props) {

    const { caravan, configurations } = props.configuration;

    const baseImage = has(caravan, 'image_inside') ? caravan.image_inside : null;
    const baseImageUri = has(baseImage, 'href') ? `/${baseImage.href}` : null;

    const caravanName = has(caravan, 'name') ? caravan.name.toLowerCase() : '';

    let decorImage = null;
    let paddingCoverImage = null;
    let foldImage = null;
    let roofLiningImage = null;

    /* eslint-disable no-trailing-spaces */
    configurations.interior.map(item => { // eslint-disable-line array-callback-return
        switch (item.category) {
            case 'decor':
                decorImage = !isNil(item.interior_image[caravanName])
                    ? `/${item.interior_image[caravanName]}`
                    : null;
                break;
            case 'padding_cover':
                paddingCoverImage = !isNil(item.interior_image[caravanName])
                    ? `/${item.interior_image[caravanName]}`
                    : null;
                break;
            case 'fold':
                foldImage = !isNil(item.interior_image[caravanName])
                    ? `/${item.interior_image[caravanName]}`
                    : null;
                break;
            case 'roof_lining':
                roofLiningImage = !isNil(item.interior_image[caravanName])
                    ? `/${item.interior_image[caravanName]}`
                    : null;
                break;
            default:
                break;
        }
    });
    /* eslint-enable no-trailing-spaces */

    return (
        <div className={style.imageContainer}>
            <img className={style.imageBase} src={baseImageUri} alt={t`Innenraum`} />
            {!isNil(decorImage) ? <img className={style.image} src={decorImage} alt={t`Dekor`} /> : ''}
            {!isNil(foldImage) ? <img className={style.image} src={foldImage} alt={t`Klappen`} /> : ''}
            {!isNil(roofLiningImage) ? <img className={style.image} src={roofLiningImage} alt={t`Himmel`} /> : ''}
            {!isNil(paddingCoverImage) ? <img className={style.image} src={paddingCoverImage} alt={t`Sitzbezüge`} /> : ''}
        </div>
    );
}

const mapStateToProps = state => ({
    configuration: state.configuration,
});
export default connect(mapStateToProps, null)(CaravanInsideImage);
